import * as R from 'remeda';

import { ZoneManagementAction, ZoneManagementState } from '.';

const initialState: ZoneManagementState = {
  editedActivityDomain: { allIds: [], byId: {} },
};

export const zoneManagementReducer = (
  state: ZoneManagementState = initialState,
  action: ZoneManagementAction,
): ZoneManagementState => {
  switch (action.type) {
    case 'page/zoneManagement/INIT':
      return R.set(state, 'editedActivityDomain', action.payload.activity);
    case 'page/zoneManagement/MOVE_ACTIVITY': {
      const { activityId, zoneId } = action.payload;

      const editedActivityDomain = R.clone(state.editedActivityDomain);

      editedActivityDomain.byId[activityId] = {
        ...editedActivityDomain.byId[activityId]!,
        zoneId, // Update zone id
        subZoneIds: [], // When moving to another zone, remove connected subzones
      };

      return R.set(state, 'editedActivityDomain', editedActivityDomain);
    }

    case 'page/zoneManagement/DISCARD':
      return R.set(state, 'editedActivityDomain', action.payload.activity);
    case 'page/zoneManagement/SAVE':
      return initialState;
    default:
      return state;
  }
};

export default zoneManagementReducer;
